import { render } from "./BGZG18.vue?vue&type=template&id=6dba474e&scoped=true"
import script from "./BGZG18.vue?vue&type=script&lang=js"
export * from "./BGZG18.vue?vue&type=script&lang=js"

import "./BGZG18.vue?vue&type=style&index=0&id=6dba474e&lang=css"
import "./BGZG18.vue?vue&type=style&index=1&id=6dba474e&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dba474e"]])

export default __exports__